<script>
import CkeditorWidget from "@/components/widgets/editor.vue";

export default {
  components: {
    CkeditorWidget,
  },
  props: {
    list: Array,
    idJadwal: String,
    idJadwalPeserta: String,
  },
  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      contentPreview: "",
    };
  },
  computed: {
    currentQuestion() {
      return this.list?.[0];
    },
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Petunjuk Essai</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <p>Silahkan tulis jawaban Anda pada kolom jawaban yang tersedia di bawah.</p>
        <p>
          Klik <strong>"Simpan Jawaban"</strong> untuk menyimpan jawaban Anda
          sebelum berpindah ke soal berikutnya.
        </p>
        <p>Klik "History Jawaban" untuk melihat riwayat jawaban yang pernah disimpan.</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div class="mym-card-case mt-2 mb-3" v-if="currentQuestion?.soal_text">
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ currentQuestion?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image mb-3"
          />

          <!-- Pertanyaan -->
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- Jawaban Preview Full Width -->
    <div class="card w-100">
      <div class="card-header bg-primary text-white">
        <h6 class="mb-0 text-white">Jawaban</h6>
      </div>
      <div class="card-body">
        <CkeditorWidget v-model="contentPreview" />
      </div>
    </div>
  </div>
</template>
